import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import useCreateEstablishmentUserExternalToken from "@/features/establishments/hooks/users/useCreateEstablishmentUserExternalToken";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface CreateEstablishmentUserTokenModalProps {
  establishmentUserId?: string;
}

const CreateEstablishmentUserTokenModal = ({ establishmentUserId }: CreateEstablishmentUserTokenModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const queryClient = useQueryClient();

  const {
    mutate: createEstablishmentUserExternalToken,
    isPending: createEstablishmentUserExternalTokenIsPending,
    isError: createEstablishmentUserExternalTokenIsError,
  } = useCreateEstablishmentUserExternalToken({
    establishmentUserId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['establishmentUserExtenalTokens', establishmentUserId] });
      setIsOpen(false);
      setMessages(['Token gerado com sucesso!']);
    },
    onError: (e) => {
      setIsOpen(false);
      setMessages(e.response?.data?.errors?.base || ['Ocorreu um erro ao gerar token']);
    }
  })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            name="create_establishment_user_external_token"
            operationKlassToCheckPermission="Admin::Establishment::UserExternalTokens::Create"
          >
            Gerar token
          </Button>
        )}
        title="Confirmar geração de Token"
        subtitle="Você tem certeza que deseja gerar um novo token?"
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-white-400"
        showClose={false}
        useCancellableFooter
        confirmButtonClassName="bg-blue-700 disabled:opacity-70"
        confirmButtonIsLoading={createEstablishmentUserExternalTokenIsPending}
        onConfirm={createEstablishmentUserExternalToken}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={createEstablishmentUserExternalTokenIsError}
        />
      )}
    </>
  )
}

export default CreateEstablishmentUserTokenModal;
